/**
 * Checks if a value is neither null nor undefined
 * @param value Value to check
 * @returns boolean indicating if the value is defined
 */
export const isDefined = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};

/**
 * Checks if multiple values are all defined (neither null nor undefined)
 * @param values Array of values to check
 * @returns boolean indicating if all values are defined
 */
export const allDefined = (...values: any[]): boolean => {
  return values.every(isDefined);
};
